module.exports = __webpack_public_path__ + "static/media/privacy-icon-offices-below.63deb719.svg";